import { Dialog, DialogActions, DialogContent, useMediaQuery, useTheme } from "@mui/material";
import { Button } from "react-bootstrap";

const ModalPrintOut = ({ constantes, open, close, children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Dialog
        open={open}
        onClose={close}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            overflowX: "hidden",
            maxWidth: "100vw",
            width: "100%",
            boxSizing: "border-box",
            margin: isMobile ? 0 : undefined,
          },
        }}
      >
        <DialogContent
          sx={{
            overflowX: "hidden",
            width: "100%",
            boxSizing: "border-box",
            px: { xs: 2, sm: 3 },
          }}
        >
          {children}
        </DialogContent>
        <DialogActions>
          <Button
            style={{ background: "#af0728", border: "none" }}
            onClick={close}
          >
            {constantes.Cancelar}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalPrintOut;

